export enum PayoutOrderHintNames {
  TAGS = 'tags',
  SEGMENTS = 'segments',
}
